module.exports = __webpack_public_path__ + "img/Inlinepad-尺寸.6d2952e7.svg";